import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import rolesService from "./rolesService";

export const getRoles = createAsyncThunk(
    "state/getAll",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return rolesService.getRoles(token);
        } catch (error) {
            const massage = error.message;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);
const rolesSlice = createSlice({
    name: "state",
    initialState: {
        roles: [],
        isRoleSucsess: false,
        isRolesError: false,
        isRoleLoading: false,
        massage: "",
    },
    reducers: {
        resetRoles: (state) => {
            state.isRoleSucsess = false;
            state.isRolesError = false;
            state.isRoleLoading = false;
            state.massage = "";
        },
    },
    extraReducers: {
        [getRoles.pending]: (state) => {
            state.isRoleLoading = true;
        },
        [getRoles.fulfilled]: (state, action) => {
            state.isRoleLoading = false;
            state.roles = action.payload;
            state.isRoleSucsess = true;
        },
        [getRoles.rejected]: (state, action) => {
            state.isRoleLoading = false;
            state.isRolesError = true;
            state.massage = action.payload;
        },
    },
});

export const { resetRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
